import { styled } from '@mui/material/styles';
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const StyledChevronIcon = styled(Icon)`
  font-weight: bold;
`;

export const StyledPaginationContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'showTotalEntries' && prop !== 'totalPages',
})<{
    showTotalEntries: boolean;
    totalPages: number;
}>`
  display: flex;
  justify-content: ${({ showTotalEntries, totalPages }) =>
        showTotalEntries || totalPages > 1 ? 'space-between' : 'flex-end'
    };
  align-items: center;
  padding: 1rem 0;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledEntriesInfo = styled(Box)`
  display: flex;
  align-items: center;
`;

export const StyledEntriesText = styled(Typography)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.secondary.main};
  font-weight: 400;
`;

export const StyledPaginationInputContainer = styled(Box)`
  display: flex;
  align-items: center;
  
  .MuiOutlinedInput-root {
    width: 80px;
    height: 40px;
    
    .MuiOutlinedInput-input {
      padding: 8px 12px;
      text-align: center;
      font-size: 0.875rem;
    }
  }
`; 